import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import * as selectorsCommon from '../selector';

import AttendContact from './AttendContact';
import AttendHistory from './AttendHistory';
import ChildApplyList from './ChildApplyList';
import ChildList from './ChildList';
import * as selectorsChild from './ChildList/selector';
import ChildNotebook from './ChildNotebook';
import HealthRecord from './ChildNotebook/HealthRecord';
import Measure from './Measure';
import News from './News';
import Notice from './Notice';
import Photos from './Photos';
import PrivateBlog from './PrivateBlog';
import { pageSelector, facilityListSelector } from './selector';

import type { PostType } from '@/components/TopMenu';
import type { UserType } from '@/types/domain/user/redux';

import TopMenu from '@/components/TopMenu';
import { uiSlice } from '@/domain/ui/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType;
}

const Content: React.FC<Props> = ({ user }) => {
  const dispatch = useDispatch();
  const posts = useSelector(selectorsCommon.postsSelector);
  const page = useSelector(pageSelector);
  const child = useSelector(selectorsChild.selectedChildSelector);
  const {
    childFacilityList,
    facilityHomepageSettings,
  } = useSelector(facilityListSelector);
  if (page === 'child' && user.attributes) {
    return (
      <ChildList
        child={child}
        username={user.name}
        attrs={user.attributes}
        facilityList={childFacilityList}
      />
    );
  }
  if (child) {
    if (page === 'childApply' && user.attributes) {
      return (
        <ChildApplyList
          child={child}
          username={user.name}
          attrs={user.attributes}
          facilityList={childFacilityList}
        />
      );
    }
    if (page === 'measure') {
      return <Measure child={child} user={user} />;
    }
    if (page === 'healthRecord') {
      return (
        <HealthRecord
          child={child}
          user={user}
          facilityList={childFacilityList}
        />
      );
    }
    if (page === 'news') {
      return <News />;
    }
    if (page === 'childNotebook') {
      return (
        <ChildNotebook
          child={child}
          user={user}
          facilityList={childFacilityList}
        />
      );
    }
    if (page === 'notice') {
      return <Notice />;
    }
    if (page === 'attendContact') {
      return (
        <AttendContact
          child={child}
          facilityList={childFacilityList}
        />
      );
    }
    if (page === 'attendHistory') {
      return <AttendHistory child={child} />;
    }
    if (page === 'photo') {
      return <Photos child={child} />;
    }
    if (page === 'blog') {
      return <PrivateBlog />;
    }
  }
  return (
    <TopMenu
      posts={posts}
      onClick={(post: PostType) => {
        if (post.key === 'openHomepage') {
          if (facilityHomepageSettings?.url && facilityHomepageSettings.url !== '') {
            window.open(facilityHomepageSettings.url, '_blank');
          }
        } else {
          dispatch(uiSlice.actions.setPage(post.key));
        }
      }}
    />
  );
};

export default Content;
